var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6 24.6H3V.3c0-.2-.2-.4-.4-.3H.4C.2 0 0 0 0 .3v26.8c0 .2.2.4.4.3h29.2c.2 0 .3-.1.3-.3v-2.2l-.3-.3zM6.2 12.7c-.2 0-.2 0-.2.2v2.5c0 .2.2.4.4.4H11c.2 0 .3-.2.3-.4V13c0-.2-.1-.4-.3-.4zm0-2.9H15l.3-.3V7c0-.2 0-.4-.3-.4H6.2l-.3.4v2.5l.3.3zm0-5.8h12.1c.2 0 .2-.2.2-.3V1.2c0-.2 0-.4-.3-.4h-12c-.2 0-.3.2-.3.4v2.5l.3.3zm0 17.7h2.3l.3-.3v-2.5c0-.2-.1-.3-.3-.3H6.2l-.3.3v2.5c0 .2.1.4.3.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.7 18.6h-3.9l-.3.3v2.5c0 .2.2.2.3.2h3.9c.1 0 .3 0 .3-.2v-2.5l-.3-.3zM25.8.8h-4.2c-.1.2-.3.2-.3.4v2.5c0 .2.1.3.3.3h4.2c.2 0 .3-.1.3-.3V1.2c0-.2 0-.4-.3-.4zm-7.4 6h2.2c.2 0 .3.1.3.3v2.6c0 .2-.1.3-.3.3h-2.2a.3.3 0 01-.3-.3V7.1c0-.2.1-.3.3-.3zm-4.2 5.8h3.4c.2 0 .3.1.3.3v2.6c0 .2-.1.3-.3.3h-3.4a.3.3 0 01-.3-.3v-2.6c0-.2.1-.3.3-.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarStacked);
export default __webpack_public_path__ + "static/media/bar-stacked.9a685eaa.svg";
export { ForwardRef as ReactComponent };